<!--
 * @Author: your name
 * @Date: 2021-02-24 16:02:23
 * @LastEditTime: 2021-02-24 16:23:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\components\Loading.vue
-->
<template>
  <div class="loading"></div>
</template>
<script>
export default {
  name: "loading",
  data() {
    return {}
  },
  created() { },
  methods: {}
}
</script>
<style lang='less' scoped>
.loading {
  position: fixed;
  // left: 20%;
  // top: 38%;
  left: 0;
  top: 0;
  background: url('../assets/img/loading.gif') rgba(255,255,255,.4) center center no-repeat;
  // width: 30vw;
  // height: 30vh;
  z-index: 1000;
  width: 100%;
  height: 100%;
}
</style>